/**
 * SGKC024A
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface SlideadjustmentunitpriceListExtractionconditionDto {

    /**
     * スライド調整単価コード
     */
    slideadjustmentunitpriceCode?: string;
    /**
     * 適用年月
     */
    applyYm?: string;
    /**
     * 適用開始年月
     */
    applyStartyearmonth?: string;
    /**
     * 適用開始日付
     */
    applyStartDate?: string;
}

